export default __webpack_public_path__ + "static/media/akril.5f9a3994.jpg";